import { isEmpty } from "lodash";
import { getBasicSettingsForPortal } from "./modules/Estore/_redux/Estore/basicSettingsCrud";
import { getDateTimeInZone, handleApiErrorResponse } from "./modules/Common/utils";
import { getAllChannels } from "./modules/Inventory/_redux/sale-stock-channels/saleStockChannelsCrud";
import { setDefaultChannel } from "./modules/Inventory/_redux/sale-stock-channels/saleStockChannelsActions";
import { actions } from "./modules/Auth/_redux/authRedux";
export function handleLogin({
    access_token,
    refresh_token,
    disableLoading,
    setLoggedIn,
    dispatch
}) {
    if (access_token && refresh_token) {
        localStorage.setItem("access_token", access_token);
    }
    disableLoading && disableLoading();
    setLoggedIn && setLoggedIn(true);
    // localStorage.setItem("lastClearDate", new Date().toISOString().split("T")[0]);
    getBasicSettingsForPortal()
        .then((res) => {
            if (!isEmpty(res?.data?.entity?.timezone || {})) {
                localStorage.setItem("lastClearDate", getDateTimeInZone(res.data.entity.timezone).split("T")[0]);
            }
        })
        .catch((err) => {
            console.log(err);
            handleApiErrorResponse(err);
        });
    try {
        dispatch(actions.login(access_token, refresh_token, window.location.origin));
        // setDefaultChannelInStore({ is_primary: true }, dispatch);
        // Open customer display in new tab on extended display after successful login
        // openCustomerDisplay(access_token);
    } catch (error) {
        console.error(error);
    }
    
}


const setDefaultChannelInStore = async (params, dispatch) => {
    try {
        
        const response = await getAllChannels(params);
        const { entities } = response.data;
        const defaultChannel = {
            id: entities[0].id,
            name: entities[0].name,
        };

        dispatch && dispatch(setDefaultChannel(defaultChannel));
        if (!localStorage.getItem("stock_search_filter")) {
            const stock_filter = {
                advance_filters: {
                    channel_ids: [entities[0].id],
                    brand_ids: [],
                    supplier_ids: [],
                    category_id: [],
                    searchKey: "",
                    searchText: "",
                    search_aisle: "",
                    search_zone: "",
                    search_Bin: "",
                    quantity_low_high: [],
                    damaged_product: [],
                    pageNumber: 1,
                    pageSize: 10,
                    product_status: 1,
                },
                display_advance_filters: false,
                channelForBulkEdit: [
                    {
                        id: entities[0].id,
                        name: entities[0].name,
                    },
                ],
                show_advance_filters: true,
            };
            localStorage.setItem("stock_search_filter", JSON.stringify({ ...stock_filter }));
        }

        if (!localStorage.getItem("stock_alert_filter")) {
            const stockAlertFilter = {
                advance_filters: {
                    channel_id: [entities[0].id],
                    brand_id: [],
                    supplier_id: [],
                    category_id: [],
                    searchKey: "",
                    min_qty: "",
                    back_order_qty: "",
                    pageNumber: 1,
                    pageSize: 10,
                },
                display_advance_filters: false,
                show_advance_filters: true,
            };
            localStorage.setItem("stock_alert_filter", JSON.stringify({ ...stockAlertFilter }));
        }
    } catch (err) {
        
        handleApiErrorResponse(err);
    }
};